import React from 'react';
import styles from './styles.css';

const Triangle = () => <div className={styles.wrapper} />;

export default Triangle;
